import { createTheme } from "@mui/material/styles";

// Shared lender design values, scoped to borrower views and their portaled dialogs.
export const borrowerAntTheme = {
  token: {
    colorPrimary: "#7057F6",
    colorInfo: "#7057F6",
    colorText: "#14213F",
    colorTextSecondary: "#68748C",
    colorBgLayout: "#F5F6FF",
    colorBgContainer: "#FFFFFF",
    colorBorder: "#E3E6F6",
    borderRadius: 12,
    borderRadiusLG: 18,
    controlHeight: 40,
    fontFamily: "Manrope, Poppins, sans-serif",
  },
};

export const createBorrowerTheme = (theme) => createTheme(theme, {
  palette: {
    primary: { main: "#7057F6" },
    secondary: { main: "#8B6CFF" },
    background: { default: "#F5F6FF", paper: "#FFFFFF" },
    text: { primary: "#14213F", secondary: "#68748C" },
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 999, textTransform: "none" } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 12 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 18 } } },
  },
});
